import './video-modal.scss'
import {ModalCloseIcon} from "../../../assets/images";
import {generateFileMediaUrl, generateFileMediaUrlWithoutDefault} from "../../../utils/generateMediaUrl";
import Slider from "react-slick";
import {Modal} from "antd";
import React, {useEffect, useRef} from "react";
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {About} from "../../../containers/homepage/about/About";


function VideoModal(props) {
    const {visible,closeModal,showCloseIcon,onCanPlay,videoData} = props;
    const ref = useRef(null)


    // console.log(videoData,'videoDatavideoData')
    return <Modal
        visible={visible}
        wrapClassName={'custom-modal'}
        closeIcon={<ModalCloseIcon/>}
        onCancel={closeModal}>
        <div className={'Img-modal-wrapper'}>
            <button className={`modal-closing-btn ${showCloseIcon ? 'show' : ''}`}
                    onClick={closeModal}>
                <ModalCloseIcon title={''}/>
            </button>
            {videoData && <video
                playsInline
                autoPlay
                loop={true}
                muted={false}
                controls={true}
                id={videoData?.id}
                ref={ref}
                src={generateFileMediaUrl(videoData?.path)}
                // poster={generateFileUrl(video?.mediaMain?.path)}
                className="video"
                onCanPlay={onCanPlay}
                onLoad={() => console.log('onLoad')}
                onChange={() => console.log('onChange')}
            />}
        </div>
    </Modal>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'settings'
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VideoModal);